import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

const state = {
  userLanguage: '',
  userProfileDetails: {},
  account: null,
  chatBubbles: [],
  signatures: [],
  inboxOptOut: null,
  inboxOptOuts: {
    data: [],
    meta: {},
  },
  sms: {
    isEnabled: false,
    shortNames: [],
  },
  keystoneFlows: [],
  uiFlags: {
    // Creating
    isCreating: false,

    // Fetching
    isFetching: false,
    isSmsFetching: false,
    isOptOutsFetching: false,
    isKeystoneFlowsFetching: false,

    // Updating
    isUpdating: false,
    isSmsUpdating: false,
    isOptOutsUpdating: false,

    // Merging
    isMerging: false,

    // Deleting
    isDeleting: false,
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
